"use client";
import * as React from "react";
const SvgArrowDownwardFilled = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "m16 8-1.41-1.41L9 12.17V0H7v12.17L1.42 6.58 0 8l8 8z" }));
export {
  SvgArrowDownwardFilled as default
};
